import { JurisdictionModalValues } from '@models/interfaces';

export const DEFAULT_JURISDICTION_MODAL_VALUES: JurisdictionModalValues = {
  id: '',
  projectType: '',
  projectSubType: '',
};
